/* ================================================================
   Ninho Bebê — JS extras: gift note, free shipping bar, sticky ATC,
   zipcode CEP, clothing guide.
   ================================================================ */

(() => {
  if (window.NinhoBebeLtExtrasLoaded) return;
  window.NinhoBebeLtExtrasLoaded = true;

  // ========== GIFT NOTE (cart drawer) ==========
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-lt-giftnote-toggle]');
    if (!t) return;
    e.preventDefault();
    t.closest('.lt-giftnote')?.classList.toggle('is-open');
  });

  const saveGiftNote = async (giftNote) => {
    const save = giftNote?.querySelector('[data-lt-giftnote-save]');
    const ta = giftNote?.querySelector('textarea');
    if (!save || !ta) return false;

    const giftMessage = ta.value.trim();
    const orderNote = giftMessage ? `Bilhete de presente: ${giftMessage}` : '';
    const originalButtonText = save.textContent;
    const msg = giftNote.querySelector('.lt-giftnote__msg') || (() => {
      const m = document.createElement('span');
      m.className = 'lt-giftnote__msg';
      m.setAttribute('role', 'status');
      m.setAttribute('aria-live', 'polite');
      save.after(m);
      return m;
    })();

    save.disabled = true;
    save.textContent = 'Salvando…';
    msg.textContent = '';

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: orderNote,
          attributes: { 'Bilhete de presente': giftMessage }
        })
      });

      if (!response.ok) throw new Error('Não foi possível atualizar o carrinho.');

      const cart = await response.json();
      const savedMessage = cart.attributes?.['Bilhete de presente'] || '';
      if ((cart.note || '') !== orderNote || savedMessage !== giftMessage) {
        throw new Error('A Shopify não confirmou o bilhete no pedido.');
      }

      ta.defaultValue = giftMessage;
      msg.classList.remove('is-error');
      msg.textContent = giftMessage ? '✓ Salvo no pedido' : '✓ Removido do pedido';
      setTimeout(() => msg.textContent = '', 2500);
      return true;
    } catch (_) {
      msg.classList.add('is-error');
      msg.textContent = 'Não foi possível salvar. Tente novamente.';
      return false;
    } finally {
      save.disabled = false;
      save.textContent = originalButtonText;
    }
  };

  document.addEventListener('click', async (e) => {
    const save = e.target.closest('[data-lt-giftnote-save]');
    if (!save) return;
    e.preventDefault();
    await saveGiftNote(save.closest('.lt-giftnote'));
  });

  // Evita que um bilhete digitado e ainda não salvo se perca ao avançar para o checkout.
  document.addEventListener('click', async (e) => {
    const checkout = e.target.closest('[name="checkout"]');
    const giftNote = document.querySelector('.lt-giftnote');
    const ta = giftNote?.querySelector('textarea');
    if (!checkout || !ta || ta.value.trim() === ta.defaultValue.trim()) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (!(await saveGiftNote(giftNote))) return;

    if (typeof window.yampiClick === 'function') {
      window.yampiClick();
      return;
    }

    const form = checkout.form;
    if (form) form.requestSubmit(checkout);
  }, true);

  // ========== CART DRAWER CROSS-SELL ==========
  const captureCartScrollState = (form, cart) => {
    const drawerInner = cart?.querySelector('.drawer__inner');
    const cartItems = cart?.querySelector('cart-drawer-items');
    const crossSell = cart?.querySelector('.lt-cart-cross-sell');

    return {
      windowX: window.scrollX,
      windowY: window.scrollY,
      drawerScrollTop: drawerInner?.scrollTop || 0,
      cartItemsScrollTop: cartItems?.scrollTop || 0,
      crossSellScrollTop: crossSell?.scrollTop || 0,
      activeSection: form.closest('.lt-cart-cross-sell') ? 'cross-sell' : 'cart'
    };
  };

  const restoreCartScrollState = (state, cart) => {
    if (!state) return;

    window.scrollTo(state.windowX, state.windowY);

    const drawerInner = cart?.querySelector('.drawer__inner');
    const cartItems = cart?.querySelector('cart-drawer-items');
    const crossSell = cart?.querySelector('.lt-cart-cross-sell');

    if (drawerInner) drawerInner.scrollTop = state.drawerScrollTop;
    if (cartItems) cartItems.scrollTop = state.cartItemsScrollTop;
    if (crossSell) crossSell.scrollTop = state.crossSellScrollTop;
  };

  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-lt-cart-cross-sell-select]');
    if (!select) return;

    const card = select.closest('[data-lt-cart-cross-sell-card]');
    const option = select.selectedOptions[0];
    const price = card?.querySelector('[data-lt-cart-cross-sell-price]');
    const comparePrice = card?.querySelector('[data-lt-cart-cross-sell-compare-price]');
    const image = card?.querySelector('[data-lt-cart-cross-sell-image]');
    const links = card?.querySelectorAll('[data-lt-cart-cross-sell-link]');
    const error = select.closest('form')?.querySelector('[data-lt-cart-cross-sell-error]');

    if (!option?.value) return;

    if (price && option.dataset.price) price.textContent = option.dataset.price;

    if (comparePrice) {
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.hidden = !option.dataset.comparePrice;
    }

    if (image && option.dataset.imageUrl) {
      image.src = option.dataset.imageUrl;
      image.alt = option.dataset.imageAlt || image.alt;
    }

    if (option.dataset.productUrl) {
      links?.forEach((link) => link.setAttribute('href', option.dataset.productUrl));
    }

    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-lt-cart-cross-sell-form]');
    if (!form) return;

    e.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-lt-cart-cross-sell-error]');
    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));
    const cart = document.querySelector('cart-drawer');
    const scrollState = captureCartScrollState(form, cart);

    if (!variantId || !button) {
      const select = form.querySelector('[data-lt-cart-cross-sell-select]');
      if (error) {
        error.textContent = 'Escolha um modelo antes de adicionar.';
        error.hidden = false;
      }
      select?.focus();
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(document.activeElement);
      }

      config.body = formData;

      const response = await fetch(routes.cart_add_url, config).then((res) => res.json());

      if (response.status) {
        throw new Error(response.description || response.message || 'Não foi possível adicionar o produto.');
      }

      if (!cart || typeof cart.renderContents !== 'function') {
        window.location = window.routes.cart_url;
        return;
      }

      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.renderContents(response);
      restoreCartScrollState(scrollState, cart);
      window.requestAnimationFrame(() => restoreCartScrollState(scrollState, cart));
      window.setTimeout(() => restoreCartScrollState(scrollState, cart), 0);
      window.setTimeout(() => restoreCartScrollState(scrollState, cart), 120);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-cross-sell',
          productVariantId: variantId,
          cartData: response
        });
      }
    } catch (err) {
      if (error) {
        error.textContent = err.message || 'Não foi possível adicionar o produto.';
        error.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  // ========== STICKY ATC ==========
  document.addEventListener('DOMContentLoaded', () => {
    const sticky = document.querySelector('[data-lt-sticky-atc]');
    if (!sticky) return;
    const trigger = document.querySelector('product-form .product-form__submit, product-form button[type="submit"], button[name="add"]');
    if (!trigger) return;
    const quantityValue = sticky.querySelector('[data-lt-sticky-qty-value]');
    const quantityDecrease = sticky.querySelector('[data-lt-sticky-qty-decrease]');
    const quantityIncrease = sticky.querySelector('[data-lt-sticky-qty-increase]');
    const stickyPrice = sticky.querySelector('[data-lt-sticky-atc-price]');
    const bundleCards = Array.from(document.querySelectorAll('[data-nb-quantity]'));

    const getSelectedBundleCard = () =>
      document.querySelector('[data-nb-quantity].is-selected') || bundleCards[0] || null;

    const getSelectedQuantity = () => {
      const selectedCard = getSelectedBundleCard();
      if (selectedCard) return Number(selectedCard.dataset.nbQuantity) || 1;

      const quantityInput = document.querySelector('product-form .quantity__input');
      return Number(quantityInput?.value) || 1;
    };

    const syncStickyState = () => {
      const selectedCard = getSelectedBundleCard();
      const quantity = getSelectedQuantity();

      if (quantityValue) quantityValue.textContent = String(quantity);

      const selectedPrice = selectedCard?.querySelector('.nb-product-bundle-price strong')?.textContent?.trim();
      if (selectedPrice && stickyPrice) stickyPrice.textContent = selectedPrice;
    };

    const preserveScroll = (callback) => {
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
      window.__ltStickyScrollX = scrollX;
      window.__ltStickyScrollY = scrollY;
      callback();
      window.scrollTo(scrollX, scrollY);
      window.requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
    };

    const selectStickyQuantity = (nextQuantity) => {
      const clampedQuantity = Math.max(1, Math.min(3, nextQuantity));
      const targetCard = bundleCards.find((card) => Number(card.dataset.nbQuantity) === clampedQuantity);

      if (targetCard) {
        preserveScroll(() => {
          bundleCards.forEach((card) => {
            const selected = card === targetCard;
            card.classList.toggle('is-selected', selected);
            card.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          const quantityInput = document.querySelector('product-form .quantity__input');
          if (quantityInput) {
            quantityInput.value = String(clampedQuantity);
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

	          const colorContainer = document.querySelector('[data-nb-kit-colors]');
	          const selectedColors = Array.from(document.querySelectorAll('[data-nb-color-value]:checked'));
	          if (colorContainer) colorContainer.setAttribute('data-nb-kit-quantity', String(clampedQuantity));
	          selectedColors.slice(clampedQuantity).forEach((input) => {
	            input.checked = false;
	          });
	
	          const sizeContainer = document.querySelector('[data-nb-size-selector]');
	          const selectedSizes = Array.from(document.querySelectorAll('[data-nb-size-value]:checked'));
	          if (sizeContainer) sizeContainer.setAttribute('data-nb-kit-quantity', String(clampedQuantity));
	          selectedSizes.slice(clampedQuantity).forEach((input) => {
	            input.checked = false;
	          });
	        });
        window.setTimeout(syncStickyState, 0);
        return;
      }

      const quantityInput = document.querySelector('product-form .quantity__input');
      if (!quantityInput) return;
      quantityInput.value = String(clampedQuantity);
      preserveScroll(() => {
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      syncStickyState();
    };

    quantityDecrease?.addEventListener('click', () => {
      selectStickyQuantity(getSelectedQuantity() - 1);
    });

    quantityIncrease?.addEventListener('click', () => {
      selectStickyQuantity(getSelectedQuantity() + 1);
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-nb-quantity]')) return;
      window.setTimeout(syncStickyState, 0);
    });

    document.addEventListener('change', (event) => {
      if (!event.target.closest('product-form .quantity__input, variant-selects')) return;
      window.setTimeout(syncStickyState, 0);
    });

    sticky.querySelector('[data-lt-sticky-atc-btn]')?.addEventListener('click', () => {
      const eventOptions = { bubbles: true, cancelable: true };
      const pointerEvent = typeof PointerEvent === 'function'
        ? new PointerEvent('pointerdown', eventOptions)
        : new MouseEvent('pointerdown', eventOptions);
      trigger.dispatchEvent(pointerEvent);
      if (trigger.type === 'button') return;
      if (!pointerEvent.defaultPrevented) trigger.click();
    });
    let triggerIsVisible = true;

    const updateStickyVisibility = () => {
      const hasPassedFirstFold = window.scrollY >= window.innerHeight;
      sticky.classList.toggle('is-visible', hasPassedFirstFold && !triggerIsVisible);
    };

    const obs = new IntersectionObserver(([entry]) => {
      triggerIsVisible = entry.isIntersecting;
      updateStickyVisibility();
    }, { rootMargin: '-100px 0px 0px 0px' });
    obs.observe(trigger);
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
    syncStickyState();
    updateStickyVisibility();
  });

  // ========== ZIPCODE shipping checker (ViaCEP) ==========
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-lt-zipcode]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('input');
    const result = form.parentElement.querySelector('[data-lt-zipcode-result]');
    const cep = (input.value || '').replace(/\D/g, '');
    if (cep.length !== 8) {
      result.className = 'lt-zipcode__result is-error';
      result.textContent = 'CEP inválido. Digite os 8 números.';
      return;
    }
    result.className = 'lt-zipcode__result';
    result.textContent = 'Calculando…';
    try {
      const data = await fetch(`https://viacep.com.br/ws/${cep}/json/`).then(r => r.json());
      if (data.erro) {
        result.className = 'lt-zipcode__result is-error';
        result.textContent = 'CEP não encontrado.';
        return;
      }
      const region = `${data.localidade} / ${data.uf}`;
      const days = ['SP','RJ','MG','PR','SC','RS','ES','GO','DF'].includes(data.uf) ? '2 a 4 dias úteis' : '4 a 8 dias úteis';
      result.className = 'lt-zipcode__result is-success';
      result.innerHTML = `📦 Para <strong>${region}</strong>: ${days}.<br>Frete grátis acima de R$199.`;
    } catch (_) {
      result.className = 'lt-zipcode__result is-error';
      result.textContent = 'Erro — tente de novo.';
    }
  });
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-lt-zipcode] input');
    if (!input) return;
    const v = input.value.replace(/\D/g, '').slice(0, 8);
    input.value = v.length > 5 ? `${v.slice(0,5)}-${v.slice(5)}` : v;
  });

  // ========== FREE SHIPPING BAR (calcula em cima do cart drawer Dawn) ==========
  const formatShippingAmount = (amountInCents) => (
    (amountInCents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
  );

  function renderShippingBar(bar, cartTotal) {
    const threshold = Number(bar.dataset.thresholdCents || 19900);
    const total = Math.max(0, Number(cartTotal) || 0);
    if (!threshold) return;

    const remaining = threshold - total;
    const progress = Math.max(0, Math.min(100, (total / threshold) * 100));
    const fill = bar.querySelector('.lt-shipping-bar__fill');
    const track = bar.querySelector('.lt-shipping-bar__track');
    const msg = bar.querySelector('.lt-shipping-bar__msg');
    if (!fill || !track || !msg) return;

    bar.dataset.cartTotal = String(total);
    bar.classList.toggle('is-complete', remaining <= 0);
    fill.style.width = `${progress}%`;
    track.setAttribute('aria-valuenow', String(Math.round(progress)));

    if (remaining > 0) {
      msg.innerHTML = `Faltam <strong>${formatShippingAmount(remaining)}</strong> para o <strong>frete grátis</strong>.`;
      msg.classList.remove('lt-shipping-bar__msg--success');
    } else {
      msg.innerHTML = '🎉 Você ganhou <strong>frete grátis</strong>!';
      msg.classList.add('lt-shipping-bar__msg--success');
    }
  }

  function updateShippingBars(cart) {
    if (!cart || !Number.isFinite(Number(cart.total_price))) return false;
    document.querySelectorAll('[data-lt-shipping-bar]').forEach((bar) => {
      renderShippingBar(bar, cart.total_price);
    });
    return true;
  }

  async function refreshShippingBar(cart) {
    if (updateShippingBars(cart)) return;
    try {
      const latestCart = await fetch('/cart.js').then(r => r.json());
      updateShippingBars(latestCart);
    } catch (_) {}
  }
  document.addEventListener('DOMContentLoaded', refreshShippingBar);
  // Refresh after Dawn cart updates
  document.addEventListener('cart:refresh', refreshShippingBar);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      window.requestAnimationFrame(() => {
        if (!updateShippingBars(event?.cartData)) refreshShippingBar();
      });
    });
  }
  // Listen on cart fetch wrappers
  const origFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0]?.toString() || '';
    const p = origFetch.apply(this, args);
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
      p.then(() => setTimeout(refreshShippingBar, 200));
    }
    return p;
  };

  // ========== CLOTHING GUIDE (interativo) ==========
  document.querySelectorAll('[data-lt-clothing-guide]').forEach(root => {
    const items = root.querySelector('[data-lt-cg-items]');
    const intro = root.querySelector('[data-lt-cg-intro]');
    function paint(btn) {
      root.querySelectorAll('[data-lt-cg-temp]').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const types = (btn.dataset.ltCgTypes || '').split(',').map(s => s.trim()).filter(Boolean);
      const links = (btn.dataset.ltCgLinks || '').split(',').map(s => s.trim()).filter(Boolean);
      if (intro) intro.textContent = `A ${btn.dataset.ltCgTemp} recomendamos:`;
      items.innerHTML = types.map((t, i) => `
        <a href="${links[i] || '#'}" class="lt-clothing-guide__item">
          <span class="lt-clothing-guide__item-icon">👕</span>
          <span>${t}</span>
          <span class="lt-clothing-guide__item-arrow">→</span>
        </a>`).join('');
    }
    root.addEventListener('click', e => {
      const btn = e.target.closest('[data-lt-cg-temp]');
      if (btn) paint(btn);
    });
    const first = root.querySelector('.is-active') || root.querySelector('[data-lt-cg-temp]');
    if (first) paint(first);
  });

  // ========== DISCOUNT POPUP (10% off) ==========
  document.addEventListener('DOMContentLoaded', () => {
    const popup = document.querySelector('[data-lt-popup]');
    if (!popup) return;
    const cookieKey = popup.dataset.cookieKey || 'lt_popup_v1';
    const delay = (parseInt(popup.dataset.delay, 10) || 6) * 1000;

    function getCookie(name) {
      return document.cookie.split('; ').find(c => c.startsWith(name + '='))?.split('=')[1];
    }
    function setCookie(name, value, days) {
      const exp = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${value}; expires=${exp}; path=/; SameSite=Lax`;
    }

    if (getCookie(cookieKey)) return; // já fechou ou inscreveu

    // Mostrar quando: (1) tempo X, OU (2) intent-to-leave (mouse no topo)
    let shown = false;
    const show = () => {
      if (shown) return;
      shown = true;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
    };
    const hide = (lockDays = 14) => {
      popup.hidden = true;
      document.body.style.overflow = '';
      setCookie(cookieKey, '1', lockDays);
    };

    setTimeout(show, delay);
    document.addEventListener('mouseleave', (e) => {
      if (e.clientY < 0 && !shown) show();
    });

    popup.addEventListener('click', (e) => {
      if (e.target.closest('[data-lt-popup-close]')) hide(7);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && shown) hide(7);
    });
    // Se o form for submetido com sucesso, lock 365 dias
    popup.querySelector('form')?.addEventListener('submit', () => setCookie(cookieKey, '1', 365));
  });

  // ========== VIDEO CARD play ==========
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.lt-video-card');
    if (!card) return;
    const v = card.querySelector('video');
    if (!v) return;
    if (v.paused) { v.play(); v.controls = true; card.classList.add('is-playing'); }
    else { v.pause(); }
  });

})();
